import { useTranslation } from 'react-i18next'

import { cn } from '@/lib/cn'

/** A loading placeholder. Flat tone, no shimmer — motion is short and flat in
 *  this system, and a pulsing grid of shimmer bars reads as broken. */
export function Skeleton({ className }: { className?: string }) {
  return (
    <div
      aria-hidden
      className={cn('bg-neutral-100 animate-pulse rounded-sm', className)}
    />
  )
}

/** The dashboard's loading shape: three counters, three tiles, two panels. */
export function DashboardSkeleton() {
  const { t } = useTranslation()

  return (
    <div
      className="flex flex-col gap-5"
      aria-busy="true"
      aria-label={t('dashboard.loading')}
    >
      <Skeleton className="h-14 w-full rounded-[var(--radius-DEFAULT)]" />
      <div className="grid gap-3.5 lg:grid-cols-3">
        <Skeleton className="h-[330px] rounded-[var(--radius-DEFAULT)]" />
        <Skeleton className="h-[330px] rounded-[var(--radius-DEFAULT)]" />
        <Skeleton className="h-[330px] rounded-[var(--radius-DEFAULT)]" />
      </div>
      <div className="grid gap-3.5 lg:grid-cols-[1.6fr_1fr]">
        <Skeleton className="h-64 rounded-[var(--radius-DEFAULT)]" />
        <Skeleton className="h-64 rounded-[var(--radius-DEFAULT)]" />
      </div>
    </div>
  )
}
